import ChangePasswordForm from 'parts/ChangePasswordForm';
import React from 'react';
import useAuth from "utils/auth/hooks";
import { Card, Layout, Row, Col, Space, Typography, Alert, message } from 'antd';
import matahariLogo from 'assets/images/mataharilogo.png';
import * as ls from "utils/localStorage";

const { Content, Footer } = Layout;
const { Text } = Typography;

export default function ChangePassword() {
  const { methods, data } = useAuth();
  const version = ls.load("api-version");

  function onFinish(){
    message.info('Please login again with your new password');
    setTimeout(() => {
      methods.handleLogout();
    }, 2000);
  }

  return (
    <Layout>
      <Content>
        <Row
          type="flex"
          justify="center"
          align="middle"
          style={{ minHeight: "100vh" }}
        >
          <Col>
            <div style={{height:'60px', width:'100%', marginBottom:'8px'}}>
              <img src={matahariLogo} style={{height:'100%', width:'100%', objectFit:'contain' }} />
            </div>
            <Alert message="You need to change password before proceeding" type="warning" showIcon style={{marginBottom:"5px"}} />
            <Card title="Change Password" bordered={false}>
              <ChangePasswordForm onFinish={onFinish} showLogout={true} />
            </Card>
            <Footer style={{ textAlign: "center" }}>
            <Space direction="vertical">
            <Text code>{`Version ${version ?? "2.0.0"}`}</Text>
              {"© Matahari Department Store, 2021"}
            </Space>            
            </Footer>
          </Col>
        </Row>        
      </Content>      
    </Layout>
  )
}
